import {
    PULS_INFO_REQUEST,
    PULS_INFO_RESULT,
    PULS_INFO_SHOW_MODAL,
    PULS_INFO_HIDE_MODAL,
    PULS_FILES_REQUEST,
    PULS_FILES_RESULT,
} from 'Redux/actionTypes';

export const pulsInfoRequest = (data) => ({
    type: PULS_INFO_REQUEST,
    payload: data
})

export const pulsInfoResult = (result) => ({
    type: PULS_INFO_RESULT,
    payload: result
})

export const showPulsInfoModal = () => ({
    type: PULS_INFO_SHOW_MODAL,
    payload: {}
});

export const showPulsInfoModalHide = () => ({
    type: PULS_INFO_HIDE_MODAL,
    payload: {}
});

export const pulsFilesRequest = (data) => ({
    type: PULS_FILES_REQUEST,
    payload: data
})

export const pulsFilesResult = (result) => ({
    type: PULS_FILES_RESULT,
    payload: result
})